// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__c0Q1z","social":"Footer_social__vUYCe","subheading":"Footer_subheading__vxOhC","heading":"Footer_heading__3-DQC","email":"Footer_email__tpB3b"};